import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schedule-entries--entry"
export default class extends Controller {
  static outlets = ["schedule-entries--week-calendar"];

  edit(event) {
    if (event.target.closest(".schedule-entry__remove-button")) {
      return
    }
    
    const baseUrl = this.element.dataset.editUrl
    const url = this.appendSearchParams(baseUrl)
    Turbo.visit(url.toString(), { frame: "modal" })
  }

  appendSearchParams(base) {
    const url = new URL(base, window.location.origin)
    
    if (this.hasScheduleEntriesWeekCalendarOutlet) {
      const searchParams = this.scheduleEntriesWeekCalendarOutlet.getSearchFormParams();
      searchParams.forEach((value, key) => {
        if (value) url.searchParams.set(key, value);
      });

      const weekStart = this.scheduleEntriesWeekCalendarOutlet.getCurrentWeekStart();
      url.searchParams.set("week_start", this.formatDate(weekStart));
    } else {
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach((value, key) => {
        url.searchParams.set(key, value);
      });
    }

    return url;
  }

  formatDate(date) {
    return date.toISOString().split('T')[0];
  }
}
